import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin } from '@zillow/constellation';

export const baseFontStyle = css`
  font-size: 14px;

  ${mediaMixin(
    'lg',
    css`
      font-size: 16px;
    `,
  )};
`;

export const StyledWrapper = styled.div`
  margin: 0 auto 16px;
  max-width: 600px;
  text-align: center;

  height: 336px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCTAWrapper = styled.div`
  margin: ${spaceMixin('sm')} auto 0px;

  ${mediaMixin(
    'lg',
    css`
      margin-top: ${spaceMixin('lg')} 0px;
    `,
  )};
`;
